import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Institution } from "../../../../../../models/institution";
import { Registration } from "../../../../../../models/registration";
import { RegistrationInstitution } from "../../../../../../models/registration-institution";
import { Role } from "../../../../../../models/role";
import { RoleInstitution } from "../../../../../../models/role-institution";
import { InstitutionControllerService } from "../../../../../../services/institution-controller/institution-controller.service";
import { RegistrationInstitutionControllerService } from "../../../../../../services/institution-controller/institution-registration-controller.service";
import { InstitutionService } from "../../../../../../services/institution-controller/institution.service";
import { RoleInstitutionControllerService } from "../../../../../../services/role-controller/role-institution-controller.service";
import { Store } from "../../../../../../services/store.service";
import {HttpResponse} from "@angular/common/http";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "institution-edit",
  templateUrl: "./institution-edit.component.html",
  styles: [],
  providers: [RoleInstitutionControllerService, ToastrService],
})
export class InstitutionEditComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  @Input() public institution: Institution;
  @Input() public dragIcons: boolean = true;
  @Input() public registrationInstitution: RegistrationInstitution;
  @Input() public roleInstitutions: RoleInstitution[];
  @Input() public institutions: Institution[];
  @Input() public unitsLength: number = 0;
  @Input() public role: Role;
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  public registration: Registration;
  public addNew: boolean;
  public subscription: any;
  public isLoading: boolean = false;
  public institutionShortName: string = "";

  constructor(private registrationInstitutionControllerService: RegistrationInstitutionControllerService,
              private roleInstitutionControllerService: RoleInstitutionControllerService,
              private institutionControllerService: InstitutionControllerService,
              private institutionService: InstitutionService,
              public store: Store,
              public toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.institutionService.editData.subscribe((data) => {
      // Common stuff
      if (!this.institution) { this.institution = data.institution; }
      this.unitsLength = data.unitsLength;
      this.addNew = data.addNew;
      // Registration Stuff
      this.registration = data.registration;
      this.registrationInstitution = data.registrationInstitution;
      // Role stuff
      if (!this.role) { this.role = data.role; }
      if (!this.roleInstitutions) { this.roleInstitutions = data.roleInstitutions; }
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public submit() {
    if (!this.institution.name) {
      this.showErrorMessage("Name is missing!");
    } else if (this.institution.url && !this.institution.url.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm)) {
      this.showErrorMessage("Url " + this.institution.url + " is invalid!");
    } else {
      if (!this.institution.id) {
        this.createInstitution(this.institution);
      } else {
        this.editInstitution(this.institution);
      }
    }
  }

  public createInstitution(institution: Institution) {
    if (!this.isLoading) {
      this.isLoading = true;
      // @ts-ignore
      this.institutionControllerService.createInstitution(institution).subscribe((data: HttpResponse<any> | string) => {
          let newInstitution;
          if (data instanceof HttpResponse) {
            // empty response from keycloak here.
            if (data.status !== 201) {
              this.isLoading = false;
              this.showErrorMessage(data.statusText);
              return;
            }
            newInstitution = institution;
            newInstitution.id = data.headers.get("location")
              .substring(data.headers.get("location").lastIndexOf("/") + 1);
          } else {
            newInstitution = JSON.parse(data);
          }

          if (this.registration && this.registration.id) {
            this.addRegistrationInstitution(newInstitution);
          } else if (this.role && this.role.id) {
            this.institutions.push(newInstitution);
            this.addRoleInstitution(newInstitution);
          } else {
            this.formSubmit.emit({ save: true, newInstitution, create: false });
            this.responseSuccessful("Institution added!");
            this.isLoading = false;
          }
        },
        (error) => {
          this.isLoading = false;
          this.showErrorMessage(error);
        },
      );
    }
  }
  public editInstitution(institution: Institution) {
    if (!this.isLoading) {
      this.isLoading = true;
      this.institutionControllerService.updateInstitution(institution).subscribe(
        () => {
          this.formSubmit.emit({ save: true, institution, create: false });
          const index = this.institutions.map((a) => a.id).indexOf(institution.id);

          this.institutions[index].name = institution.name;
          this.institutions[index].url = institution.url;
          this.institutions[index].shortName = institution.shortName;

          this.roleInstitutions.filter((ri) => ri.institutionId === institution.id).forEach((ri) => {
            ri.institutionName = institution.name;
          });
          this.institutionService.updateData();
          this.responseSuccessful("Institution saved!");
          this.resetForm();
        },
        (error) => this.showErrorMessage(error),
        () => this.isLoading = false,
      );
    }
  }

  public addRoleInstitution(institution: Institution) {
    if (this.role.id) {
      if (this.roleInstitutions.length > 0) {
        if (!this.unitsLength) {
          this.roleInstitutionControllerService.createRoleInstitution(this.role.id, institution.id).subscribe(
            (roleInstitution) => {
              this.responseSuccessful("Institution added to Role!");
              this.formSubmit.emit({ save: true, institution, create: true });
              this.institutionService.updateData();
              roleInstitution.institutionName = this.institutions.find((i) => i.id === roleInstitution.institutionId)?.name;
              this.roleInstitutions.push(roleInstitution);
              this.resetForm();
            },
            (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
            () => this.isLoading,
          );

        } else {
          this.error("Remove Role Unit before changing Role Institution", "Error");
        }
      } else {
        this.roleInstitutionControllerService.createRoleInstitution(this.role.id, institution.id).subscribe(
          (roleInstitution) => {
            this.responseSuccessful("Institution added to Role!");
            this.formSubmit.emit({ save: true, institution, create: true });
            this.institutionService.updateData();
            roleInstitution.institutionName = this.institutions.find((i) => i.id === roleInstitution.institutionId)?.name;
            this.roleInstitutions.push(roleInstitution);
            this.resetForm();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
          () => this.isLoading = false,
        );
      }
    }
  }

  public addRegistrationInstitution(institution: Institution) {
    if (this.registration) {
      if (this.registrationInstitution) {
        if (!this.unitsLength) {
          this.registrationInstitutionControllerService.createRegistrationInstitution(this.registration.id, institution.id).subscribe(
            () => {
              this.responseSuccessful("Institution added to Registration!");
              this.formSubmit.emit({ save: true, institution, create: true });
              this.institutionService.updateData();
              this.resetForm();
            },
            (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
            () => this.isLoading = false,
          );
        } else {
          this.error("Remove Unit before changing Institution", "Error");
        }
      } else {
        this.registrationInstitutionControllerService.createRegistrationInstitution(this.registration.id, institution.id).subscribe(
          () => {
            this.responseSuccessful("Institution added to Registration!");
            this.formSubmit.emit({ save: true, institution, create: true });
            this.institutionService.updateData();
            this.resetForm();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
          () => this.isLoading = false,
        );
      }
    }
  }

  public resetForm() {
    this.institution = null;
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
    this.resetForm();
  }

  public nameChanged(value): void {
    this.institutionShortName = value;
    this.institution.shortName = this.institutionShortName.substring(0, 20);
  }

  public isNew(item) {
    return item === undefined;
  }

}
